import React, {useState, useEffect, useRef, useImperativeHandle, forwardRef} from "react";
import {getListConversationWA, getMoreConversationsWA, getSingleConversationWA, setMessagesAsReadWA} from "../../../../../hooks/ConversationProvider";
import SimpleBar from "simplebar-react";
import "simplebar/src/simplebar.css";
import ImageUserChat from "../../../../../utils/ImageUserChat";
import moment from "moment";
import ParserTemplComponentsUserListWA from "../../../../../utils/ParserTemplComponentsUserListWA";
import ParserTemplComponentsAppList from "../../../../../utils/ParserTemplComponentsAppList";
import {
    BoxLoader,
    BusinessListConversations, WrapLoadMoreMessage, PaginationListConv,
    SearchListConv,
    BusinessConvListWrapper
} from "../../../../../styles/businessConversation";
import Loader from "../../../../../utils/Loader";
import Main_settings from "../../../../../styles/main_settings/Main_settings";
import {ButtonRoundIcon} from "../../../../../styles/Commons";
import SvgAdd01 from "../../../../../source/svg/Add01";
import ReactPaginate from 'react-paginate';

const BusListConversationsWA = forwardRef(function BusListConversationsWA(props, ref) {
    const properties = props
    const [conversations, setConversations] = useState([])
    const [totalConversations, setTotalConversations] = useState(0)
    const [thisCurrentConversation, setThisCurrentConversation] = useState(false)
    const [loadMoreConversations, setLoadMoreConversations] = useState(false)
    const [changeObj, setChangeObj] = useState("")
    const heightbar = properties.heightList
    const [currentPage, setCurrentPage] = useState(0);
    const numberPerPage = 10;
    const [searchTerm, setSearchTerm] = useState("");
    const [searchResults, setSearchResults] = useState(null);
    const [isSearching, setIsSearching] = useState(false);
    const [searchActive, setSearchActive] = useState(false);
    const [debouncedSearch, setDebouncedSearch] = useState("");
    const [lastSearchedTerm, setLastSearchedTerm] = useState("");
    const cancelSearchRef = useRef(false);

    const scrollbar = useRef(null)

    useEffect(() => {
        loadPage(0);
    }, []);

    useEffect(() => {
        if (props.updateConversation) {
            loadPage(currentPage);
        }
    }, [props.updateConversation]);

    useEffect(() => {
        if (props.updatelistConversations) {
            loadPage(currentPage);
        }
    }, [props.updatelistConversations]);

    // Funzione per avviare la ricerca solo su click
    const handleSearch = async () => {
        if (searchTerm.trim().length >= 4) {
            setIsSearching(true);
            cancelSearchRef.current = false;
            let allResults = [];
            let page = 0;
            let keepGoing = true;
            while (keepGoing) {
                if (cancelSearchRef.current) {
                    setIsSearching(false);
                    return;
                }
                const res = await getListConversationWA({app_id:props.app._id, page, pageSize: numberPerPage, search: searchTerm});
                if (res && res.conversations && res.conversations.length) {
                    allResults = allResults.concat(res.conversations);
                    if (res.conversations.length < numberPerPage) {
                        keepGoing = false;
                    } else {
                        page++;
                    }
                } else {
                    keepGoing = false;
                }
            }
            setSearchResults(allResults);
            setIsSearching(false);
            setSearchActive(true);
            setCurrentPage(0);
            setLastSearchedTerm(searchTerm);
        }
    };

    // Funzione per annullare la ricerca
    const handleCancelSearch = () => {
        cancelSearchRef.current = true;
        setSearchTerm("");
        setSearchResults(null);
        setIsSearching(false);
        setSearchActive(false);
        setLastSearchedTerm("");
    };

    useEffect(() => {
        if (!searchActive && searchTerm === "") {
            setSearchResults(null);
            setIsSearching(false);
        }
    }, [searchTerm, searchActive]);

    async function loadPage(page) {
        setLoadMoreConversations(true);
        let params = {app_id:props.app._id, page, pageSize: numberPerPage};
        let calllistconversations = await getListConversationWA(params);
        setLoadMoreConversations(false);
        if (!calllistconversations.error) {
            setConversations(calllistconversations.conversations)
            setTotalConversations(calllistconversations.total_conversations)
            if (!thisCurrentConversation && calllistconversations.conversations.length > 0) {
                properties.setCurrentConversation(calllistconversations.conversations[0])
                setThisCurrentConversation(calllistconversations.conversations[0])
            }
            setChangeObj(new Date())
            setCurrentPage(page);
        }
    }

    const totalPages = Math.ceil(totalConversations / numberPerPage);

    // Calcolo pagine per la ricerca
    const totalSearchPages = searchResults ? Math.ceil(searchResults.length / numberPerPage) : 0;
    const paginatedSearchResults = searchResults ? searchResults.slice(currentPage * numberPerPage, (currentPage + 1) * numberPerPage) : [];

    // Modifica handlePageClick per gestire la paginazione dei risultati di ricerca
    const handlePageClick = async event => {
        const selected = event.selected;
        if (searchActive && searchResults !== null) {
            setCurrentPage(selected);
        } else {
            await loadPage(selected);
        }
    }

    async function updateCurrentConversation(e, tConversation) {
        e.preventDefault();
        if (thisCurrentConversation && thisCurrentConversation.conversations._id != tConversation.conversations._id) {
            properties.setCurrentConversation(tConversation);
            setThisCurrentConversation(tConversation);

            // Marca come letti i messaggi della conversazione selezionata
            await setMessagesAsReadWA({ conversation_id: tConversation.conversations._id });
            // Aggiorna la lista per riflettere lo stato letto
            setConversations(prevConvs => {
                return prevConvs.map(conv =>
                    conv.conversations._id === tConversation.conversations._id
                        ? {
                            ...conv,
                            last_message: {
                                ...conv.last_message,
                                updates: {
                                    ...conv.last_message.updates,
                                    console: {
                                        ...conv.last_message.updates.console,
                                        read: "true"
                                    }
                                }
                            }
                        }
                        : conv
                );
            });
        }
    }

    // Funzione per aggiornamento smart da socket
    const handleSocketUpdate = (conversation_id) => {
        getSingleConversationWA({ app_id: props.app._id, conversation_id })
            .then(response => {
                if (response && response.conversations && response.conversations.length) {
                    const updatedConv = response.conversations[0];
                    setConversations(prevConvs => {
                        const idx = prevConvs.findIndex(c => c.conversations._id === updatedConv.conversations._id);
                        if (idx !== -1) {
                            // Aggiorna la conversazione nella pagina corrente
                            let newConvs = [...prevConvs];
                            newConvs[idx] = updatedConv;
                            newConvs.sort((a, b) => new Date(b.last_message.date.date) - new Date(a.last_message.date.date));
                            return newConvs;
                        } else if (currentPage === 0) {
                            // Se sono già nella prima pagina, aggiungi la conversazione aggiornata in cima (rimuovendola se già presente)
                            let filteredConvs = prevConvs.filter(c => c.conversations._id !== updatedConv.conversations._id);
                            let newConvs = [updatedConv, ...filteredConvs];
                            newConvs = newConvs.slice(0, numberPerPage); // mantieni il pageSize
                            newConvs.sort((a, b) => new Date(b.last_message.date.date) - new Date(a.last_message.date.date));
                            return newConvs;
                        } else {
                            // Se NON sono nella prima pagina, non aggiorno nulla
                            return prevConvs;
                        }
                    });
                    // Aggiorna anche la conversazione attiva se corrisponde
                    if (
                        props.currentConversation &&
                        props.currentConversation.conversations &&
                        props.currentConversation.conversations._id === updatedConv.conversations._id
                    ) {
                        props.setCurrentConversation(updatedConv);
                    }
                }
            });
    };

    useImperativeHandle(ref, () => ({
        handleSocketUpdate
    }));

    const HEIGHT_SEARCH = 54;
    const showPaginator = (searchActive && totalSearchPages > 1) || (!searchActive && totalPages > 1);
    const scrollableHeight = heightbar - HEIGHT_SEARCH;

    return (
        <BusinessConvListWrapper>
            <SearchListConv>
              <input
                type="text"
                placeholder="Cerca nei messaggi..."
                value={searchTerm}
                onChange={e => {
                  setSearchTerm(e.target.value);
                  if (!searchActive) setSearchResults(null);
                  if (e.target.value === "") handleCancelSearch();
                }}
                style={{
                  width: "100%",
                  padding: "8px 20px",
                  borderRadius: 40,
                  border: "1px solid #ccc"
                }}
                onKeyDown={e => {
                  if (e.key === 'Enter' && searchTerm.trim().length >= 4 && searchTerm.trim() !== lastSearchedTerm.trim()) handleSearch();
                  if (e.key === 'Enter' && searchTerm.trim() === lastSearchedTerm.trim()) handleCancelSearch();
                }}
              />
              {isSearching ? (
                <button
                  style={{
                    marginLeft: 8,
                    background: Main_settings.color02,
                    color: "#fff",
                    border: "none",
                    borderRadius: 40,
                    padding: "8px 20px",
                    cursor: "pointer"
                  }}
                  onClick={handleCancelSearch}
                  aria-label="Annulla ricerca"
                >
                  Annulla
                </button>
              ) : searchActive && searchTerm.trim() === lastSearchedTerm.trim() ? (
                <button
                  style={{
                    marginLeft: 8,
                    background: Main_settings.color02,
                    color: "#fff",
                    border: "none",
                    borderRadius: 40,
                    padding: "8px 20px",
                    cursor: "pointer"
                  }}
                  onClick={handleCancelSearch}
                  aria-label="Annulla ricerca"
                >
                  Annulla
                </button>
              ) : searchTerm.trim().length >= 4 && searchTerm.trim() !== lastSearchedTerm.trim() ? (
                <button
                  style={{
                    marginLeft: 8,
                    background: Main_settings.color02,
                    color: "#fff",
                    border: "none",
                    borderRadius: 40,
                    padding: "8px 20px",
                    cursor: "pointer"
                  }}
                  onClick={handleSearch}
                  aria-label="Cerca"
                >
                  Cerca
                </button>
              ) : (
                <button
                  style={{
                    marginLeft: 8,
                    background: "#eee",
                    color: "#888",
                    border: "none",
                    borderRadius: 40,
                    padding: "8px 20px",
                    cursor: "not-allowed"
                  }}
                  disabled
                  aria-label="Cerca"
                >
                  Cerca
                </button>
              )}
            </SearchListConv>
          <SimpleBar style={{height: scrollableHeight}} ref={scrollbar}>
 
            {/* Fine barra di ricerca */}
            {(() => {
                if (isSearching) {
                    return (
                        <BoxLoader heightloader={props.heightList}>
                            <Loader width="40" height="40" color={Main_settings.color02} secondaryColor={Main_settings.color02} type="03" />
                        </BoxLoader>
                    )
                }
                // Se ricerca attiva, mostra solo i risultati paginati
                const convsToShow = searchActive && searchResults !== null ? paginatedSearchResults : (searchResults !== null ? searchResults : conversations);
                if (convsToShow) {
                    if (convsToShow.length && thisCurrentConversation) {
                        return (
                            <BusinessListConversations style={{paddingTop: HEIGHT_SEARCH, paddingBottom: 0}}>
                            {/* Lista conversazioni */}
                            {(() => {
                                return convsToShow.map((child, i) => {
                                    let currentconversation = child
                                    let nameuser
                                    let targetuser
                                    let unreadmessage = 1

                                    if (currentconversation.last_message.updates && currentconversation.last_message.updates.console && currentconversation.last_message.updates.console.read === "true") unreadmessage = 0
                                    if (currentconversation.user) {
                                        nameuser = currentconversation.user.name
                                        targetuser = currentconversation.user
                                    }
                                    if (currentconversation.last_message) {
                                        let ddate = moment(currentconversation.last_message.date.date).format('ll');
                                        ddate = ddate.substring(0, ddate.length - 5);
                                        return (
                                            <div className={`listitem_conversation ${unreadmessage ? "listitem_conversation_unread" : ""} ${currentconversation.conversations._id === thisCurrentConversation.conversations._id ? "listitem_conversation_active" : ""}`}  onClick={e => updateCurrentConversation(e, currentconversation)} key={i}>
                                                <div className="listitem_pic_user_conv">
                                                    <ImageUserChat user={targetuser}/>
                                                </div>
                                                <div className="listitem_txt_user_conv">
                                                    <p className="subtxt_user_name">{nameuser}</p>
                                                    {(() => {
                                                        if (currentconversation.last_message.from === "user") {
                                                            return (
                                                                <>
                                                                    <p className="subtxt_user_conv">
                                                                        <ParserTemplComponentsUserListWA message={currentconversation.last_message} code={currentconversation.last_message.message_data}/>
                                                                    </p>
                                                                </>
                                                            )
                                                        } else {
                                                            let targetcontent
                                                            let length = 15;
                                                            if (currentconversation.last_message.message_data.type === "file" && currentconversation.last_message.message_data.name) {
                                                                targetcontent = currentconversation.last_message.message_data.name
                                                            }
                                                            else {
                                                                let htmltext = ""
                                                                if (currentconversation.last_message.message_data && currentconversation.last_message.message_data.body) htmltext= currentconversation.last_message.message_data.body.replace(/<[^>]+>/g, '').trim()
                                                                targetcontent = htmltext
                                                            }
                                                            let trimmedText = targetcontent.substring(0, length) + "...";
                                                            return (
                                                                <>
                                                                    <p className="subtxt_user_conv">
                                                                        <span>{properties.app.name}: </span>{trimmedText}
                                                                    </p>
                                                                </>
                                                            )
                                                        }

                                                    })()}
                                                </div>
                                                <div className="listitem_date_user_conv">
                                                    <p>{ddate}</p>
                                                </div>
                                            </div>
                                        )
                                    } else {
                                        return (
                                            <div className={`listitem_conversation ${currentconversation.conversations._id === thisCurrentConversation.conversations._id ? "listitem_conversation_active" : ""}`}
                                                onClick={e => updateCurrentConversation(e, currentconversation)} key={i}>
                                                <div className="listitem_pic_user_conv">
                                                    <ImageUserChat user={targetuser}/>
                                                </div>
                                                <div className="listitem_txt_user_conv">
                                                    <p className="subtxt_user_name">{nameuser}</p>
                                                    <p className="subtxt_user_conv">No messages</p>
                                                </div>
                                            </div>
                                        )
                                    }

                                })
                            })()}
                            </BusinessListConversations>
                        )
                    } else {
                        return (
                            <div>
                                <p>Non ci sono ancora conversazioni</p>
                            </div>
                        )
                    }
                }
                else {
                    return (
                        <BoxLoader heightloader={props.heightList}>
                            <Loader width="40" height="40" color={Main_settings.color02} secondaryColor={Main_settings.color02} type="03" />
                        </BoxLoader>
                    )
                }

            })()}
          </SimpleBar>
          {/* Il paginatore è visibile solo se serve, ora fuori da SimpleBar */}
          {!isSearching && showPaginator ? (
            <PaginationListConv>
              <ReactPaginate
                previousLabel={'<<'}
                nextLabel={'>>'}
                breakLabel={'...'}
                pageCount={searchActive ? totalSearchPages : totalPages}
                marginPagesDisplayed={1}
                pageRangeDisplayed={1}
                onPageChange={handlePageClick}
                containerClassName={'pagination'}
                activeClassName={'active'}
                forcePage={currentPage}
                disabled={isSearching}
              />
            </PaginationListConv>
          ) : null}
        </BusinessConvListWrapper>
    );
});

export default BusListConversationsWA;
